<script setup>
defineProps({
  transaction: {
    type: Object,
  },
});

function formatMoney(v) {
  const total = Number(v || 0);
  return total.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatDate(d) {
  if (!d) return '';
  const date = new Date(d);
  return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

const emit = defineEmits(['edit', 'pay']);

const editTrasaction = (data) => {
  emit('edit', data);
};

const getContrastYIQ = (hexcolor) => {
  if (!hexcolor || hexcolor.length < 7) return '#0b2545';
  const r = parseInt(hexcolor.substring(1, 3), 16);
  const g = parseInt(hexcolor.substring(3, 5), 16);
  const b = parseInt(hexcolor.substring(5, 7), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#213E60' : '#ffffff';
};
</script>

<template>
  <div class="invoice-transaction-item">
    <div
      class="invoice-transaction-card"
      @click="editTrasaction(transaction)"
      data-bs-toggle="modal"
      data-bs-target="#detailsTransaction"
      v-tooltip="{
        content: 'Ver detalhes',
        distance: 15,
      }"
    >
      <div
        class="invoice-transaction-icon d-none d-lg-flex"
        :style="{ color: transaction.category_color, backgroundColor: `${transaction.category_color}20` }"
        v-tooltip="{
          content: transaction.category_name,
          distance: 15,
        }"
      >
        <i
          :class="'fas ' + transaction.category_icon + ' row-transactions-icons'"
        ></i>
      </div>

      <div class="invoice-transaction-main">
        <div class="invoice-transaction-header">
          <div class="invoice-transaction-title-wrap">
            <h6 class="invoice-transaction-title mb-0">
              {{ transaction.description }}
              {{
                transaction.recurrence == 'Installments'
                  ? '(' + transaction.current_installment + '/' + transaction.end_installment + ')'
                  : ''
              }}
            </h6>

            <div class="d-lg-none mt-2">
              <span
                class="invoice-transaction-category-badge"
                :style="{ color: transaction.category_color, backgroundColor: `${transaction.category_color}20` }"
              >
                <i
                  class="me-1"
                  :class="'fas ' + transaction.category_icon + ' row-transactions-icons-badge'"
                ></i>
                {{ transaction.category_name }}
              </span>
            </div>
          </div>

          <div class="invoice-transaction-values text-end">
            <p class="invoice-transaction-date mb-1">
              {{ formatDate(transaction.date) }}
            </p>
            <span
              class="invoice-transaction-amount"
              :class="
                transaction.type == 'despesa'
                  ? 'text-danger'
                  : transaction.type == 'receita'
                    ? 'text-success'
                    : 'text-primary'
              "
            >
              {{ formatMoney(transaction.amount) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invoice-transaction-item {
  border-bottom: 1px solid #e9eef5;
}

.invoice-transaction-card {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 88px;
  padding: 16px 18px;
  border-radius: 18px;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.invoice-transaction-card:hover {
  background: #f8fafc;
  cursor: pointer;
}

.invoice-transaction-icon {
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(33, 62, 96, 0.08);
}

.row-transactions-icons {
  font-size: 21px;
}

.row-transactions-icons-badge {
  font-size: 12px;
}

.invoice-transaction-main {
  flex: 1;
  min-width: 0;
}

.invoice-transaction-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.invoice-transaction-title-wrap {
  min-width: 0;
  flex: 1;
}

.invoice-transaction-title {
  color: #213e60;
  font-size: 1.02rem;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invoice-transaction-date {
  color: #7c8dab;
  font-size: 0.9rem;
  font-weight: 500;
}

.invoice-transaction-amount {
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.2;
}

.invoice-transaction-category-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 991.98px) {
  .invoice-transaction-card {
    min-height: auto;
    padding: 14px 14px;
    gap: 12px;
  }

  .invoice-transaction-header {
    align-items: flex-start;
  }

  .invoice-transaction-title {
    white-space: normal;
    font-size: 0.98rem;
  }

  .invoice-transaction-values {
    min-width: fit-content;
  }

  .invoice-transaction-amount {
    font-size: 1.05rem;
  }

  .invoice-transaction-date {
    font-size: 0.82rem;
  }
}

@media (max-width: 575.98px) {
  .invoice-transaction-card {
    padding: 14px 12px;
  }

  .invoice-transaction-header {
    gap: 12px;
  }

  .invoice-transaction-title {
    font-size: 0.94rem;
  }

  .invoice-transaction-amount {
    font-size: 0.98rem;
  }

  .invoice-transaction-date {
    font-size: 0.78rem;
  }

  .invoice-transaction-category-badge {
    padding: 7px 10px;
    font-size: 0.7rem;
  }
}
</style>
